import { createContext, useContext, useState } from "react";

const GameContext = createContext();

export const useGameContext = () => useContext(GameContext);

export const GameProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [score, setScore] = useState(0);

  return (
    <GameContext.Provider value={{ isPlaying, setIsPlaying, score, setScore }}>
      {children}
    </GameContext.Provider>
  );
};